<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item-group>
				<div v-if="deveExibirAcaoConcluirEdicao">
					<v-list-item
						v-az-auth="permissaoConcluirEdicaoDocumento"
						data-testid="action-convite"
						v-if="temPermissao"
						@click="$emit('concluir-edicao-documento')"
					>
						<v-list-item-icon>
							<tooltip-informacao
								mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
								:tamanho-icone="tamanhoIconeMenu"
								v-if="possuiTermoDesentranhamento()"
								class="mr-2"
								color="primary"
							></tooltip-informacao>
							<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Concluir Edição</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<v-list-item
					data-testid="action-convite"
					@click="tratarEventoConvidarSignatarios"
					v-if="exibirAcaoConvidarSignatarios()"
					v-az-auth="permissaoConvidarSignatarios"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Convite</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider v-if="exibirAcaoConvidarSignatarios"></v-divider>

				<v-list-item
					v-if="exibirAcaoDesentranhar()"
					@click="verificarRedigirTermoDesentranhamento"
					v-az-auth="permissaoDesentranharDocumento"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else class="material-icons" :size="tamanhoIconeMenu">mdi-close</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Desentranhar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					class="list-item-height"
					v-if="exibirAcaoCancelar()"
					data-testid="action-cancelar"
					@click="$emit('cancelar')"
					v-az-auth="permissaoCancelarDocumento"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else :size="tamanhoIconeMenu" class="material-icons mr-2"
							>mdi-close-circle-outline
						</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="texto-menu-interno">Cancelar</v-list-item-title>
				</v-list-item>

				<v-list-item
					data-testid="action-baixar"
					v-if="exibirAcaoBaixar()"
					@click="$emit('baixar')"
					v-az-auth="permissaoBaixarDocumento"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
														Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-download</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Baixar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<div
					v-if="
						!documentoOuAnexoEstaJuntado(documentoOuAnexo) &&
						!documentoOuAnexoEstaJuntadoDesatualizado(documentoOuAnexo)
					"
				>
					<v-list-item
						class="list-item-height"
						v-if="temPermissao"
						data-testid="action-excluir"
						@click="$emit('excluir')"
						v-az-auth="permissaoExcluirDocumento"
					>
						<v-list-item-icon>
							<tooltip-informacao
								:mensagem="getMensagemTooltip()"
								:tamanho-icone="tamanhoIconeMenu"
								v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
								class="mr-2"
								color="primary"
							></tooltip-informacao>
							<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-delete</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>

				<v-list-item
					v-if="exibirAcaoEnviarPncp()"
					v-az-auth="permissaoPncpEnviar"
					class="list-item-height"
					data-testid="action-enviar-pncp"
					@click="$emit('enviar-pncp')"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Envia o documento para o PNCP."
							:tamanho-icone="tamanhoIconeMenu"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-send</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Enviar PNCP</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-if="exibirAcaoExcluirPncp()"
					v-az-auth="permissaoPncpExcluir"
					class="list-item-height"
					data-testid="action-excluir-pncp"
					@click="$emit('excluir-pncp')"
				>
					<v-list-item-icon>
						<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-delete</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Excluir PNCP</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>
<script>
import documentoMixin from '@/views/mixins/documento'
import { opcaoSimNao, situacoes, situacoesEdocs } from '@/core/constants'
import signatario from '@/views/mixins/signatarios/signatario'
import validacaoAta from '@/views/mixins/validacaoAta'
import TooltipInformacao from '@/views/components/TooltipInformacao.vue'

export default {
	name: 'listagem-documentos-btn-mais-acoes',
	components: { TooltipInformacao },
	mixins: [documentoMixin, signatario, validacaoAta],
	props: {
		documentoOuAnexo: {
			type: Object,
			default: () => null,
		},
		permissaoConcluirEdicaoDocumento: {
			type: String,
			required: true,
		},
		permissaoExcluirDocumento: {
			type: String,
			required: true,
		},
		permissaoBaixarDocumento: {
			type: String,
			required: true,
		},
		permissaoCancelarDocumento: {
			type: String,
			required: true,
		},
		permissaoConvidarSignatarios: {
			type: String,
			required: true,
		},
		permissaoDesentranharDocumento: {
			type: String,
			required: true,
		},
		permissaoPncpEnviar: {
			type: String,
			default: '',
		},
		permissaoPncpExcluir: {
			type: String,
			default: '',
		},
		hasAuthority: {
			type: Boolean,
		},
		exibirAcoesPncp: {
			type: Boolean,
		},
	},
	emits: [
		'tratar-evento-desentranhar',
		'concluir-edicao-documento',
		'baixar',
		'excluir',
		'convidar-signatarios',
		'enviar-pncp',
		'excluir-pncp',
	],
	data() {
		return {
			tamanhoIconeMenu: '18px',
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
		}
	},
	computed: {
		temPermissao() {
			return this.hasAuthority
		},
		deveExibirAcaoConcluirEdicao() {
			return (
				this.temPermissao &&
				this.isDocumento(this.documentoOuAnexo) &&
				this.documentoEstaCriado(this.documentoOuAnexo)
			)
		},
	},
	methods: {
		tratarEventoConvidarSignatarios() {
			this.$emit('convidar-signatarios')
		},
		exibirAcaoConvidarSignatarios() {
			return (
				!this.ehTermoDeDesentranhamento() &&
				this.ehDocumentoEmRascunho() &&
				this.hasAuthority &&
				this.isProcessoDigitalAtivo
			)
		},
		exibirAcaoDesentranhar() {
			return !this.ehTermoDeDesentranhamento() && this.ehDocumentoJuntado()
		},
		ehDocumentoJuntado() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO.value
		},
		ehDocumentoEmRascunho() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.RASCUNHO.value
		},
		verificarRedigirTermoDesentranhamento() {
			this.$emit('tratar-evento-desentranhar')
		},
		possuiTermoDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.possuiTermoDesentranhamento
		},
		ehTermoDeDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.ehTermoDesentranhamento
		},
		exibirAcaoCancelar() {
			return (
				!this.ehTermoDeDesentranhamento() &&
				(this.ehDocumentoJuntado() || this.documentoOuAnexoEstaJuntadoDesatualizado(this.documentoOuAnexo))
			)
		},
		exibirAcaoBaixar() {
			return (
				!this.documentoOuAnexoEstaJuntadoDesatualizado(this.documentoOuAnexo) &&
				!this.documentoOuAnexoEstaDesatualizado(this.documentoOuAnexo)
			)
		},
		isDocumentoEnviadoEdocs() {
			return (
				situacoesEdocs.AGUARDANDO.value === this.documentoOuAnexo.situacaoEdocs ||
				situacoesEdocs.SINCRONIZADO.value === this.documentoOuAnexo.situacaoEdocs
			)
		},
		getMensagemTooltip() {
			if (this.isDocumentoEnviadoEdocs()) {
				return 'Não é possível realizar essa ação, pois o documento já foi ou está sendo enviado ao e-Docs.'
			}

			return 'Existe um termo de desentranhamento em elaboração para este documento. Clique na ação para acessar as etapas da elaboração.'
		},
		exibirAcaoEnviarPncp() {
			return this.exibirAcoesPncp && this.documentoOuAnexo.situacaoPncp !== situacoes.DOCUMENTO_PNCP.ENVIADO.value
		},
		exibirAcaoExcluirPncp() {
			return this.exibirAcoesPncp && this.documentoOuAnexo.situacaoPncp === situacoes.DOCUMENTO_PNCP.ENVIADO.value
		},
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item
	padding 0 5px !important

.v-list-item__icon
	margin auto 5px !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
